// extracted by mini-css-extract-plugin
export default {"house":"index_house_LbTvA"};